/* LuluCamel Wishlist — localStorage based, no app needed */
(function() {
  var KEY = 'lc-wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function saveList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateBadge();
    paintHearts();
  }
  function findItem(id) {
    return getList().find(function(i) { return String(i.id) === String(id); });
  }

  window.lcWishlist = {
    list: getList,
    add: function(item) {
      var list = getList();
      if (!list.find(function(i) { return String(i.id) === String(item.id); })) {
        list.push(item);
        saveList(list);
      }
    },
    remove: function(id) {
      saveList(getList().filter(function(i) { return String(i.id) !== String(id); }));
    },
    toggle: function(btn) {
      var id = btn.dataset.wishId;
      var handle = btn.dataset.wishHandle;
      if (window.lcWishlist.has(id)) {
        window.lcWishlist.remove(id);
        return;
      }
      // Fetch product data from Shopify API (avoids risky data attributes)
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          window.lcWishlist.add({
            id: id,
            handle: handle,
            title: p.title,
            url: p.url,
            img: p.featured_image ? p.featured_image.replace(/(\.[^.]+)$/, '_400x$1') : '',
            price: p.price ? (p.price / 100).toFixed(2) : ''
          });
        })
        .catch(function() {
          // Fallback: add with minimal data
          window.lcWishlist.add({ id: id, handle: handle, title: handle, url: '/products/' + handle, img: '', price: '' });
        });
    },
    has: function(id) { return !!findItem(id); }
  };

  function updateBadge() {
    var count = getList().length;
    var badge = document.getElementById('NoonWishCount');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function paintHearts() {
    document.querySelectorAll('.lc-wish-btn').forEach(function(btn) {
      btn.classList.toggle('active', window.lcWishlist.has(btn.dataset.wishId));
    });
  }

  // Inject heart buttons into product cards AFTER page load
  // (avoids interfering with theme's image slider initialization)
  function injectHearts() {
    document.querySelectorAll('.card__media:not([data-lc-wish])').forEach(function(media) {
      media.setAttribute('data-lc-wish', '1');
      // Find product handle from the card's link
      var card = media.closest('.card, [data-product-id], li, .grid__item');
      var link = card ? card.querySelector('a[href*="/products/"]') : null;
      if (!link) return;
      var m = link.getAttribute('href').match(/\/products\/([^?\/]+)/);
      if (!m) return;
      var handle = m[1];
      var btn = document.createElement('button');
      btn.className = 'lc-wish-btn';
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.dataset.wishHandle = handle;
      btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 21C7 16.5 3 13 3 8.8 3 6 5.2 4 7.8 4c1.7 0 3.2.9 4.2 2.3C13 4.9 14.5 4 16.2 4 18.8 4 21 6 21 8.8c0 4.2-4 7.7-9 12.2z"/></svg>';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleByHandle(btn, handle);
      });
      // Mark as active if already wishlisted
      if (isWishlisted(handle)) btn.classList.add('active');
      media.appendChild(btn);
    });
  }

  function isWishlisted(handle) {
    try {
      var list = JSON.parse(localStorage.getItem('lc-wishlist')) || [];
      return list.some(function(i) { return i.handle === handle; });
    } catch (e) { return false; }
  }

  function toggleByHandle(btn, handle) {
    if (isWishlisted(handle)) {
      var list = JSON.parse(localStorage.getItem('lc-wishlist')) || [];
      list = list.filter(function(i) { return i.handle !== handle; });
      localStorage.setItem('lc-wishlist', JSON.stringify(list));
      btn.classList.remove('active');
      updateBadge();
      return;
    }
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        var list = JSON.parse(localStorage.getItem('lc-wishlist')) || [];
        list.push({
          id: p.id,
          handle: handle,
          title: p.title,
          url: p.url,
          img: p.featured_image || '',
          price: p.price ? (p.price / 100).toFixed(2) : ''
        });
        localStorage.setItem('lc-wishlist', JSON.stringify(list));
        btn.classList.add('active');
        updateBadge();
      });
  }

  // Run on load and observe for dynamically added cards
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectHearts);
  } else {
    injectHearts();
  }
  // Re-run for infinite scroll / AJAX loaded products
  var observer = new MutationObserver(function() { injectHearts(); });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function() {
    updateBadge();
    paintHearts();
    renderWishlistPage();
  });

  /* Wishlist page rendering */
  function normalizeItem(item) {
    if (!item) return null;
    var id = item.id || item.product_id || item.variant_id;
    var title = item.title || item.name || item.product_title;
    var url = item.url || item.link || item.product_url || (item.handle ? '/products/' + item.handle : null);
    var img = item.img || item.image || item.featured_image || '';
    var price = item.price || '';
    // Reject items with placeholder/broken image URLs
    if (img === 'undefined' || img === 'null') img = '';
    if (!id || !title || !url) return null;
    return { id: id, title: title, url: url, img: img, price: price };
  }

  function renderWishlistPage() {
    var grid = document.getElementById('LcWishlistGrid');
    if (!grid) return;
    // DEBUG MODE: ?debug=wishlist shows raw storage data for diagnosis
    if (window.location.search.indexOf('debug=wishlist') !== -1) {
      var raw = localStorage.getItem(KEY);
      grid.innerHTML = '<div style="grid-column:1/-1;background:#f9f9f9;border:1px solid #ddd;border-radius:8px;padding:16px;font-family:monospace;font-size:12px;white-space:pre-wrap;word-break:break-all;">RAW localStorage (lc-wishlist):\n\n' + (raw ? raw.replace(/</g, '&lt;') : '(empty)') + '</div>';
      var emptyDbg = document.getElementById('LcWishlistEmpty');
      if (emptyDbg) emptyDbg.style.display = 'none';
      return;
    }
    var list = getList();
    var empty = document.getElementById('LcWishlistEmpty');
    var validItems = list.map(normalizeItem).filter(function(i) { return !!i; });
    if (validItems.length === 0) {
      grid.innerHTML = '';
      if (empty) empty.style.display = 'block';
      return;
    }
    if (empty) empty.style.display = 'none';
    grid.innerHTML = validItems.map(function(item) {
      var safeTitle = String(item.title).replace(/"/g, '&quot;').replace(/</g, '&lt;');
      var imgHtml = item.img
        ? '<a href="' + item.url + '"><img src="' + item.img + '" alt="' + safeTitle + '" loading="lazy" style="width:100%;aspect-ratio:1;object-fit:cover;display:block;" onerror="this.style.display=\'none\'"></a>'
        : '';
      return '<div class="lc-wish-card" style="border:1px solid #eee;border-radius:12px;overflow:hidden;background:#fff;">' +
        imgHtml +
        '<div class="lc-wish-info" style="padding:14px;">' +
          '<a href="' + item.url + '" class="lc-wish-title" style="font-size:14px;color:#1a1a1a;text-decoration:none;display:block;min-height:40px;">' + safeTitle + '</a>' +
          '<div class="lc-wish-price" style="font-weight:700;margin:8px 0;font-size:16px;">' + (item.price && parseFloat(item.price) > 0 ? 'AED ' + item.price : '') + '</div>' +
          '<button class="lc-wish-remove" data-remove-id="' + item.id + '" style="background:none;border:1px solid #ddd;border-radius:8px;padding:8px 16px;font-size:13px;cursor:pointer;color:#666;">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
    // Log for debugging
    console.log('[Wishlist] Rendered ' + validItems.length + ' of ' + list.length + ' items');
  }

  document.addEventListener('click', function(e) {
    var rm = e.target.closest('[data-remove-id]');
    if (rm) {
      window.lcWishlist.remove(rm.getAttribute('data-remove-id'));
      renderWishlistPage();
    }
  });
})();
